import React from 'react'
import { Provider } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
// Import auth components
import { Auth0Provider } from '@auth0/auth0-react'
import CompletedRequestForm from './components/CompletedRequestForm'
import MockOrderForm from './components/orderForm/MockOderFormInfo'
import OrderForm from './components/orderForm/OrderFormInfo'
import SecureEHRRoute from './components/SecureEHRRoute'
import auth0Config from './features/auth/auth0/config/auth0'
import Callback from './features/auth/components/Callback'
import Launch from './features/auth/components/Launch'
import Login from './features/auth/components/Login'
import LoginCallback from './features/auth/components/LoginCallback'
import SecureRoute from './features/auth/components/SecureRoute'
import RadyIntegration from './pages/RadyIntegration'
import { store } from './store'
import CernerLaunch from './features/auth/components/CernerLaunch'
import CernerCallback from './features/auth/components/CernerCallback'

/**
 * The main App component, which sets up routing and the overall application structure.
 * It fetches all page configurations on startup and dynamically generates routes.
 */
const App: React.FC = () => {
  return (
    <Provider store={store}>
      <Auth0Provider {...auth0Config}>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/launch" element={<Launch />} />
          <Route path="/epic-sandbox/callback" element={<Callback />} />
          <Route path="/cerner/launch" element={<CernerLaunch />} />
          <Route path="/cerner/callback" element={<CernerCallback />} />
          <Route
            path="/mock"
            element={
              <SecureRoute>
                <MockOrderForm />
              </SecureRoute>
            }
          />
          <Route
            path="/form"
            element={
              <SecureEHRRoute>
                <OrderForm />
              </SecureEHRRoute>
            }
          />
          <Route
            path="/form/complete"
            element={
              <SecureEHRRoute>
                <CompletedRequestForm />
              </SecureEHRRoute>
            }
          />
          <Route
            path="/rady-integration"
            element={
              <SecureEHRRoute>
                <RadyIntegration />
              </SecureEHRRoute>
            }
          />
          <Route path="/health" element={<div>Health check successful</div>} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Auth0Provider>
    </Provider>
  )
}

export default App
